/**
 * Prompt Manager key for the reco set-generation instructions. The model keeps or drops each
 * code-ranked candidate for brand fit and writes its suggestion; gaps, findings and ranking
 * are computed in opportunities-engine, not by the prompt.
 */
export const OPPORTUNITY_RECO_SELECTION_PROMPT_USED_IN = 'opportunity-reco-selection';
